import React from 'react';
import { colors, typography, radius, spacing } from '../../../theme';

/**
 * Concise list of notable PRs (capped), with a "View all →" footer.
 */
const PersonalBests = ({ prs = [], onViewAll }) => {
  if (prs.length === 0) return null;

  const visible = prs.slice(0, 5);

  return (
    <div style={{ marginBottom: spacing.lg }}>
      <div style={styles.header}>
        <div style={{ ...typography.sectionHeading, color: colors.text }}>Personal Bests</div>
        {prs.length > visible.length && (
          <button onClick={onViewAll} style={styles.viewAllBtn}>View all</button>
        )}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: spacing.sm }}>
        {visible.map((pr) => (
          <div key={`${pr.exercise_name}|${pr.rep_range}`} style={styles.row}>
            <div style={{ ...typography.body, color: colors.text, fontWeight: '600' }}>{pr.exercise_name}</div>
            <div style={{ ...typography.caption, color: colors.textMuted }}>
              {pr.weight} kg × {pr.reps}
              {pr.rep_range && <span style={{ color: colors.textSubtle }}> · {pr.rep_range} reps</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  header: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    marginBottom: spacing.md,
  },
  viewAllBtn: {
    background: 'none', border: 'none', cursor: 'pointer',
    ...typography.caption, color: colors.gold, fontWeight: '700', padding: '0 4px', minHeight: '44px',
  },
  row: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: `${spacing.sm} ${spacing.md}`,
    background: colors.surface2, borderRadius: radius.sm,
    border: `1px solid ${colors.border}`,
  },
};

export default PersonalBests;
